export type ProgramNames = 'qantas' | 'velocity';

export interface LoyaltyProgramConfig {
  program: ProgramNames;
  label: string;
  placeholder: string;
  type: 'flight' | 'hotel';
}

export const LOYALTY_PROGRAMS_CONFIG: Array<LoyaltyProgramConfig> = [
  {
    program: 'qantas',
    label: 'Qantas Frequent Flyer',
    placeholder: 'Enter Qantas frequent flyer number',
    type: 'flight',
  },
  {
    program: 'velocity',
    label: 'Velocity Frequent Flyer',
    placeholder: 'Enter Velocity frequent flyer number',
    type: 'flight',
  },
];

export const INITIAL_LOYALTY_PROGRAM_MEMBER_NUMBER_MAP: Record<ProgramNames, string> = LOYALTY_PROGRAMS_CONFIG.reduce(
  (acc, config) => {
    acc[config.program] = '';
    return acc;
  },
  {} as Record<ProgramNames, string>,
);
